import { cn } from "@/lib/utils";

import { getFundingBadgeTextColor, resolveFundingBrand } from "./smart-catalog.utils";

type Props = {
    code: string | null | undefined;
    className?: string;
};

/** Badge coloré d'un financeur, avec les couleurs officielles Walter. */
export function FundingBadge({ code, className }: Props) {
    const brand = resolveFundingBrand(code);

    return (
        <span
            className={cn("inline-flex h-5 shrink-0 items-center rounded-md px-2 py-0.5 text-xs font-semibold leading-none", className)}
            style={{ backgroundColor: brand.color, color: getFundingBadgeTextColor(brand.color) }}
        >
            {brand.name}
        </span>
    );
}
